module.exports = __webpack_public_path__ + "img/virtual_placement_image.767e1587.jpg";